import { Link } from 'react-router-dom';
import { Movie } from '@/mocks/movies';

interface HotMoviesProps {
  movies: Movie[];
}

export default function HotMovies({ movies }: HotMoviesProps) {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
            🔥 热门<span className="text-primary-500">推荐</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-400">大家都在看的热门电影，千万别错过</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {movies.map((movie, index) => (
            <HotMovieCard key={movie.id} movie={movie} rank={index + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}

function HotMovieCard({ movie, rank }: { movie: Movie; rank: number }) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group flex gap-4 bg-background-100 border border-background-200 rounded-lg p-4 hover:border-primary-500/50 transition-all duration-300 cursor-pointer"
    >
      <div className="relative flex-shrink-0">
        <div className="w-20 h-28 md:w-24 md:h-32 rounded-md overflow-hidden">
          <img
            src={movie.posterUrl}
            alt={movie.title}
            title={`${movie.title} - 热门推荐`}
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute -top-2 -left-2 w-6 h-6 flex items-center justify-center rounded-full bg-primary-500 text-foreground-50 text-xs font-heading font-bold">
          {rank}
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-sm md:text-base font-semibold text-foreground-50 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-400">
          <span className="text-accent-500 font-heading font-bold">{movie.rating}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-500"></span>
          <span>{movie.year}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-500"></span>
          <span>{movie.duration}</span>
        </div>
        <p className="mt-2 text-xs text-foreground-400 line-clamp-2 leading-relaxed">{movie.description}</p>
        <div className="flex items-center gap-1.5 mt-3 flex-wrap">
          {movie.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}